import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../Assets/logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Toggle the navbar menu on click
  const toggleNavbar = () => setIsOpen(!isOpen);
  const handleSignup = () => navigate("/signup");
  const handleLogin = () => navigate("/login");

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="bg-gradient-to-r from-gray-800 to-gray-900 fixed w-full z-20 top-0 start-0">
      <div className="max-w-screen-xl flex items-center justify-between mx-auto p-4">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3">
          <img src={logo} className="h-12" alt="Logo" />
        </Link>

        {/* Hamburger Icon for Mobile View */}
        <button
          onClick={toggleNavbar}
          className="md:hidden text-white text-3xl"
          aria-label="Toggle navigation"
        >
          ☰
        </button>

        {/* Desktop View - Navbar Links */}
        <div className="hidden md:flex items-center justify-between w-full md:w-auto md:order-1">
          <ul className="flex space-x-8 rtl:space-x-reverse items-center">
            <li>
              <Link
                to="/"
                className={`block py-2 px-3 ${
                  isActive("/") ? "text-blue-700 font-bold" : "text-white"
                } hover:text-blue-500`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={`block py-2 px-3 ${
                  isActive("/about") ? "text-blue-700 font-bold" : "text-white"
                } hover:text-blue-500`}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`block py-2 px-3 ${
                  isActive("/contact")
                    ? "text-blue-700 font-bold"
                    : "text-white"
                } hover:text-blue-500`}
              >
                Contact
              </Link>
            </li>
          </ul>

          {/* Desktop View - Right-aligned Buttons */}
          <div className="flex space-x-4 items-center">
            <button
              type="button"
              onClick={handleLogin}
              className="text-white font-medium rounded-lg text-sm px-4 py-2 hover:bg-blue-600"
            >
              Login
            </button>
            <button
              type="button"
              onClick={handleSignup}
              className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-4 py-2"
            >
              Signup
            </button>
          </div>
        </div>
      </div>

      {/* Mobile View - Dropdown Menu */}
      <div
        className={`${
          isOpen ? "block" : "hidden"
        } md:hidden bg-gray-900 w-full p-4`}
      >
        <ul className="flex flex-col items-start space-y-4">
          <li>
            <Link
              to="/"
              className={`block py-2 px-3 ${
                isActive("/") ? "text-blue-700 font-bold" : "text-white"
              } hover:text-blue-500`}
              onClick={toggleNavbar}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className={`block py-2 px-3 ${
                isActive("/about") ? "text-blue-700 font-bold" : "text-white"
              } hover:text-blue-500`}
              onClick={toggleNavbar}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={`block py-2 px-3 ${
                isActive("/contact") ? "text-blue-700 font-bold" : "text-white"
              } hover:text-blue-500`}
              onClick={toggleNavbar}
            >
              Contact
            </Link>
          </li>
        </ul>

        {/* Mobile View - Buttons */}
        <div className="flex flex-col items-start mt-4 space-y-4">
          <button
            type="button"
            onClick={() => {
              handleLogin();
              toggleNavbar();
            }}
            className="text-white border border-white hover:bg-blue-600 font-medium rounded-lg text-sm px-4 py-2"
          >
            Login
          </button>
          <button
            type="button"
            onClick={() => {
              handleSignup();
              toggleNavbar();
            }}
            className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-4 py-2"
          >
            Signup
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
